/**
 * Extracts a numeric ID from a tagged TSV column value.
 *
 * @param col   - The raw column string, e.g. `"__bid:42"`
 * @param prefix - The expected prefix, e.g. `"__bid:"`
 * @returns The parsed integer, or `undefined` if the input is missing,
 *          does not start with the prefix, or the numeric part is not a valid integer.
 */
export function parseRealId(col: string | undefined, prefix: string): number | undefined {
  if (col == null || col === '') return undefined;
  if (!col.startsWith(prefix)) return undefined;
  const raw = col.slice(prefix.length);
  const num = parseInt(raw, 10);
  if (isNaN(num) || num < 0) return undefined;
  // Reject floats: parseInt('3.7', 10) silently truncates to 3
  if (String(num) !== raw) return undefined;
  return num;
}
